<template>
  <div :class="{'finished': finished}">
        <div class="mtn h4 x-column x-sm mtn x-2-2 pull-right "><button class="finishButton" v-if="finished" @click="backToDashboard()">Back to Dashboard</button></div>
    <div class="questionNumberWrapper" v-if="finished">
      
      <button class="choice" v-for="question,questionNo in questions" :class="{'answered': question.commited,
      'correct': question.commited && question.correct,
      'incorrect': question.commited && !question.correct }
      "
      @click="currentQuestionIndex=questionNo">
      {{questionNo+1}}
      </button>
      <button class="choice finish x-icon-flag-checkered" @click="currentQuestionIndex=questions.length" data-x-icon=""></button>
<!-- <pre>
  {{sendFinishingResults}}
</pre>
 -->
    </div>
    <div class="questionWrapper">
      <transition-group name="list" tag="p" mode="out-in">
        <div v-if="currentQuestionIndex == questions.length" key="finish">
          <h1>SCORE: {{calculatedScore}}</h1>
          <h4>questions answered: {{calculateTriedQuestions}}</h4>
          <h4 v-if = "paid">questions answered correctly: {{calculateCorrectQuestions}}</h4>
          <h4 v-if = "serverFinishingResults != false">!Questions answered correctly: {{serverFinishingResults}}</h4>
          <!-- <pre> -->
            <!-- {{questions}}  -->
          <!-- </pre> -->
        </div>
      <div v-for="question,qindex in questions" v-if="qindex==currentQuestionIndex" :class="{'answered': question.commited}" v-bind:key="question.id">
        <h4 class="mtn h4 x-column x-sm mtn x-1-2 "><span>Question {{qindex+1}}/{{questions.length}}</span><span class="smallID">id:{{question.id}}</span></h4>
        <div class="mtn h4 x-column x-sm mtn x-2-2 pull-right ">
          <span v-if="!finished">{{timeSpent}}</span>
          <button class="finishButton" v-if="!finished" @click="finishTesting()">Finish Test</button></div>
        <div class="questionBox">
          <div class="inner" v-html="question.question"></div>
        </div>

        <multiple-choice-single-answer v-if="question.type=='multiple_choice'" :question="question" :paid="paid" @answer="answer(question, qindex, $event.choice, $event.choiceIndex )" ></multiple-choice-single-answer>

        <multiple-choice-multi-answer v-if="question.type=='multiple_choice_multi_answer'" :question="question" :paid="paid" @answer="answerMultipleChoice(question, qindex)" ></multiple-choice-multi-answer>

        <acceptable-statement v-if="question.type=='acceptable_statement' || question.type=='valid_statement'" :question="question" :paid="paid" @answer="answerMultipleChoice(question, qindex)" ></acceptable-statement>

        <drag-and-match v-if="question.type=='drag_and_match'" :question="question" :paid="paid" @answer="answerDraggable(question, qindex)" ></drag-and-match>

        <multi-drag-and-match v-if="question.type=='multi_drag_and_match'" :question="question" :paid="paid" @answer="answerDraggable(question, qindex)" ></multi-drag-and-match>

        <input-answer v-if="question.type=='input_answer'" :question="question" :paid="paid" @answer="answer_input(question, qindex)" ></input-answer>


        <button v-if="question.commited" @click="nextQuestion()">{{continueOrFinish}}</button>

<!-- 








        <div class="type_input" v-if="question.type=='input_answer'">
          <input type="text" v-model="currentInput">
  
          <div v-if="question.commited && question.correct" class="congratulations">
            Your answer is correct!
          </div>
          <div v-if="question.commited && !question.correct" class="sorry">
            Your answer is incorrect. You Entered {{question.userAnswer}}. Correct answer is {{question.answers_input}}
          </div>
  
          <button v-if="!question.commited" @click="answer_input(currentQuestion,currentQuestionIndex)">Submit</button>
          <button v-if="question.commited" @click="nextQuestion()">Continue</button>
          <button v-if="question.commited && question.explanation_input" @click="showExplanation=true">Show Explanation</button>

        </div> -->

        <div class="explanation" v-if="question.commited && showExplanation" v-html="question.explanation_input"></div>




      </div>
      </transition-group>
    <!--         <div class="">
        <h4 class="mtn h4"><span>Question {{currentQuestionIndex+1}}/{{questions.length}}</span></h4>

         <div class="questionBox">
          <div class="inner" v-html="currentQuestion.question"></div>
        </div>

        <div v-if="currentQuestion.type=='multiple_choice'">
          <div class="choices">
            <div class="choice" v-for="choice,index in currentQuestion.answers_multiple">
              <button @click="answer(currentQuestion,currentQuestionIndex,choice)">{{String.fromCharCode(index+65)}}</button>
              <span v-html="choice.answer"></span>
            </div>
          </div>
        </div>


        <div class="type_input" v-if="currentQuestion.type=='input_answer'">
          <input type="text" v-model="currentInput">
          <button @click="answer_input(currentQuestion,currentQuestionIndex)">Submit</button>
          </div> 
        </div> -->

    </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import draggable from 'vuedraggable'
import VueSticky from 'vue-sticky'
import MultipleChoiceSingleAnswer from './QuizModels/MultipleChoiceSingleAnswer.vue'
import MultipleChoiceMultiAnswer from './QuizModels/MultipleChoiceMultiAnswer.vue'
import AcceptableStatement from './QuizModels/AcceptableStatement.vue'
import DragAndMatch from './QuizModels/DragAndMatch.vue'
import MultiDragAndMatch from './QuizModels/MultiDragAndMatch.vue'
import InputAnswer from './QuizModels/InputAnswer.vue'
import _ from 'underscore'
const lpad = require("underscore.string/lpad");
export default {
  components: {
    draggable,
    "multiple-choice-single-answer" : MultipleChoiceSingleAnswer,
    "multiple-choice-multi-answer" : MultipleChoiceMultiAnswer,
    "acceptable-statement" : AcceptableStatement,
    "drag-and-match" : DragAndMatch,
    "multi-drag-and-match" : MultiDragAndMatch,
    "input-answer" : InputAnswer
  },
  directives: {
  'sticky': VueSticky,
  },

  name: 'quiz',
  props: ['questions', 'paid', 'start'],
  data () {
    return {
      finished: false,
      msg: 'Welcome to Your Vue.js App',
      currentQuestionIndex: 0,
      showExplanation: false,
      currentInput: "",
      test: ["test"],
      serverFinishingResults: false,
      intervalId: undefined,
      timeSpent: '00:00:00',
    }
  },
  mounted: function(){
    let vm = this;
    this.intervalId = setInterval(function(){
          var timeFrom = (new Date() - vm.start) / 1000 ;
          var hours = parseInt(timeFrom / 3600)
          var minutes = parseInt(( timeFrom / 60 ) % 60)
          var seconds = parseInt(timeFrom % 60)
          vm.timeSpent = lpad(hours,2,"0") + ':' + lpad(minutes,2,"0") + ':' + lpad(seconds,2,"0")
          // vm.timeSpent = hours + ':' + minutes + ':' + seconds
          // console.log (this.changes);
    }, 1000);
  },
  methods:{
    sendAnswer: function(id, correct){
      var vm = this;

      vm.$http.get('https://biolympiads.com/wp-json/bioquiz/v1/answerQuestion?question_id='+id+'&correct='+correct).then(response => {
        console.log(response);
      }, response => {
        console.error(response);
      });

    },
    backToDashboard: function(){
      var vm = this;
      console.log('clickedBack')
      vm.$emit('back', 'back');
    },
    finishTesting: function(){
      var vm = this;
      vm.finished = true;
      vm.currentQuestionIndex = vm.questions.length;
      
      vm.$http.post('https://biolympiads.com/wp-json/bioquiz/v1/getResult', { answers : vm.sendFinishingResults }).then(response => {
        console.log(response);
        vm.serverFinishingResults = parseInt(response.body);
      }, response => {
        console.error(response);
      });

    },
    nextQuestion: function(){
      var vm = this;
      vm.currentQuestionIndex++;
      vm.showExplanation = false;
      if(vm.questions.length == vm.currentQuestionIndex){
        vm.finishTesting();
      }

    },
    answer: function(question,qindex,choice,choiceIndex){
      var vm = this;
      question.correct = choice.is_correct
      question.answers_multiple[choiceIndex].selected = !question.answers_multiple[choiceIndex].selected;
      question.commited = true
      vm.sendAnswer(question.id, question.correct);
      Vue.set(vm.questions, qindex, question);
      Vue.set(vm.questions, qindex, Vue.util.extend({}, vm.questions[qindex]));
      // this.$emit('update:foo', question)
      // setTimeout( () => { vm.currentQuestionIndex++}, 600);
    },
    onAnswer : function (question, qindex, $event){
      console.log('onAnswer', question, qindex, $event);
      var vm = this;

    },
    answer_input : function(question,qindex,choice){
      var vm = this;

      question.correct = (question.answers_input == question.userAnswer)
      question.commited = true
      
      vm.sendAnswer(question.id, question.correct);
      Vue.set(vm.questions, qindex, question);
      Vue.set(vm.questions, qindex, Vue.util.extend({}, vm.questions[qindex]));

    },
    answerMultipleChoice: function(question,qindex){
      console.log(question);

      var vm = this;
      question.correct = true;
      question.partial = false;

      question.commited = true
      question.answers_multiple.forEach(function(choice){
        question.correct = question.correct && !!choice.selected == choice.is_correct
        question.partial = question.correct || !!choice.selected == choice.is_correct
      })
      
      vm.sendAnswer(question.id, question.correct);
      Vue.set(vm.questions, qindex, question);
      Vue.set(vm.questions, qindex, Vue.util.extend({}, vm.questions[qindex]));

    },
    answerDraggable: function(question,qindex){
      console.log(question);
      var vm = this;
      question.correct = true;
      question.partial = false;

      question.commited = true;
      question.drag_and_match.forEach(function(choice){
        question.correct = question.correct && !!( choice.answer.indexOf(choice.correct_match) == 0 )
        question.partial = question.correct || !!( choice.answer.indexOf(choice.correct_match) == 0 )
      });

      vm.sendAnswer(question.id, question.correct);
      Vue.set(vm.questions, qindex, question);
      Vue.set(vm.questions, qindex, Vue.util.extend({}, vm.questions[qindex]));

    },

    selectAcceptableAnswer: function(question, qindex, choiceIndex, selected){
      var vm = this;
      question.answers_multiple[choiceIndex].selected = selected;
      Vue.set(vm.questions, qindex, question);
    },
    _makeChoiceAnswers: function($event, question, qindex){
      var vm = this;
      console.log('amazing', $event);
      // question.drag_and_match.forEach(function(choice, index){
      //   if(!question.drag_and_match[index].answer){
      //     question.drag_and_match[index].answer = [];
      //     Vue.set(vm.questions, qindex, question);
      //   }
      // })
      Vue.set(vm.questions, qindex, Vue.util.extend({}, vm.questions[qindex]));
    },
    swap: function(from, to){
      var vm = this;
      // Vue.set(vm.questions[vm.currentQuestionIndex].drag_and_match[from].answer, 0, vm.questions[vm.currentQuestionIndex].drag_and_match[to].answer);
      // console.log(vm.questions[vm.currentQuestionIndex].drag_and_match[from], vm.questions[vm.currentQuestionIndex].drag_and_match[to]);
      // Vue.set(vm.questions, vm.currentQuestionIndex, Vue.util.extend({}, vm.questions[vm.currentQuestionIndex]));

    },
    removeChoice(choiceIndex){
      var vm = this;
      console.log(choiceIndex);
      Vue.set(vm.questions[vm.currentQuestionIndex].drag_and_match[choiceIndex], 'answer', []);
      Vue.set(vm.questions, vm.currentQuestionIndex, Vue.util.extend({}, vm.questions[vm.currentQuestionIndex]));
    },
    checkMove: function(evt){
      console.log(evt);
      let from = evt.draggedContext;
      let to   = evt.relatedContext;
      // evt.dragged.classList.add('amazing');
      // res = this.privateCheckMove(evt)
      // this.canDrag=res;
      // this.futureIndex = evt.draggedContext.futureIndex;
      if(evt.to.id == 'questionBox'){
        return true;
      }
      else if(to.list.length == 0){
        return true;
      }
      else if(to.list.length == 1){
        return false;
      }
      else{
        return false;
      }
    },
    checkMoveInner: function(evt){
      var vm = this;
      // console.log(evt);
      let from       = evt.draggedContext;
      let fromIndex  = parseInt(evt.from.dataset.index)
      let to         = evt.relatedContext;
      let toIndex    = parseInt(evt.to.dataset.index)
      // evt.dragged.classList.add('amazing');
      // res = this.privateCheckMove(evt)
      // this.canDrag=res;
      // this.futureIndex = evt.draggedContext.futureIndex;
      if(evt.to.id == 'questionBox'){
        return true;
      }
      else if(from.futureIndex == 1){
        // console.log('swap1', evt);
        // if(evt.from && evt.to)
        var fromOrig    = vm.questions[vm.currentQuestionIndex].drag_and_match[fromIndex].answer
        var toOrig      = vm.questions[vm.currentQuestionIndex].drag_and_match[toIndex].answer

        from    = toOrig.slice();
        to      = fromOrig.slice();
        // fromVal = vm.questions[vm.currentQuestionIndex].drag_and_match[from].answer
        // toVal   = vm.questions[vm.currentQuestionIndex].drag_and_match[from].answer
        // console.log('swap', from, to)
        // vm.swap(parseInt(evt.from.dataset.index), parseInt(evt.to.dataset.index));

        return false;
      }
      else if(to.list.length == 0 || to.index == -1){
        return true;
      }
      else if(to.list.length == 1){
        return false;
      }
      else{
        return false;
      }
    },

  },
  computed:{
    sendFinishingResults: function() {
      var vm = this;
      var result = {};
      vm.questions.forEach(el => {

        if(el.type == 'multiple_choice' || el.type == 'multiple_choice_multi_answer'){
          result[el.id] = el.answers_multiple.map((el, index) => {
            el.index = index;
            return el;
          })
          .filter(el => {
            return el.selected;
          })
          .map( el => {
            return el.index;
          })
        }

        else if (el.type == 'valid_statement' || el.type == 'acceptable_statement') {
          result[el.id] = el.answers_multiple.map((el, index) => {
            el.index = index;
            return el;
          })
          .filter(el => {
            return el.selected;
          })
          .map( el => {
            return el.index;
          })
        }

        else if (el.type == 'drag_and_match' || el.type == 'multi_drag_and_match') {
          result[el.id] = el.drag_and_match.map((el, index) => {
            var obj = {}
            obj[index] = el.answer;
            // el.index = index;
            return obj;
          })
          result[el.id] = Object.assign(...result[el.id]);
          // .filter(el => {
          //   return el.selected;
          // })
          // .map( el => {
          //   return el.index;
          // })
        }

        else if (el.type == 'input_answer') {
          result[el.id] = (el.userAnswer) ? el.userAnswer : "";
          // result[el.id] = Object.assign(...result[el.id]);
          // .filter(el => {
          //   return el.selected;
          // })
          // .map( el => {
          //   return el.index;
          // })
        }
      
      })


      return result;
    },
    continueOrFinish : function() {
      var vm = this;
      return ((vm.questions.length - 1) == vm.currentQuestionIndex) ? 'Finish' : 'Continue'
    },
    calculateTriedQuestions: function(){
      var vm = this;
      var commited = 0;
      for(var i = 0; i < vm.questions.length; i++){
        if(vm.questions[i].commited)
          commited += 1;
      }
      return commited;
    },
    calculateCorrectQuestions: function(){
      var vm = this;
      var correct = 0;
      for(var i = 0; i < vm.questions.length; i++){
        if(vm.questions[i].correct)
          correct += 1;
      }
      return correct;
    },
    calculatedIncorrectQuestions: function(){
      var vm = this;
      var incorrect = 0;
      for(var i = 0; i < vm.questions.length; i++){
        if(!vm.questions[i].correct)
          incorrect += 1;
      }
      return incorrect;

    },
    calculatedScore: function(){
      var vm = this;
      if(vm.paid){
        return parseInt(vm.calculateCorrectQuestions*100/vm.questions.length) + '%';
      } else {
        return parseInt(vm.serverFinishingResults*100/vm.questions.length) + '%';
      }
    },
    currentQuestion : function(){
      var vm = this;
      return vm.questions[vm.currentQuestionIndex];
    },
    currentQuestionAnswer: function(){
      var vm = this;
      var question = vm.questions[vm.currentQuestionIndex];

      console.log('question', question);
      var answerArray = [];

      for (var i = 0; i < question.answers_multiple.length; i++) {
          console.log(question.answers_multiple[i]);
          if(question.answers_multiple[i].is_correct)
            answerArray.push(String.fromCharCode(i+65));
          //Do something
      }

      return answerArray.join(', ');


    }
  }
}
</script>

<style lang="scss">

.smallID {
  display: block;
  font-size: 17px;
  margin-left: 4px;
  color: #d2cccc;
}

.dragBox{
  min-height:20px;
  min-width: 20px;
  background: #efefef; 
      text-align: center;
      padding: 20px;
}
.dragBox.sticky{
    width: 30.66666%;
}
.dragElement {
  background: white;
    border: 1px solid black;
    margin-bottom: 5px;
    color: black;
    font-size: 33px;
    display: inline-block;
    margin-right: 5px;
    padding: 0 8px;
}
.matchBox{
    min-height: 50px;
    border: 1px dashed grey;
    min-width: 50px;
    text-align: center;
    padding: 5px 10px;
    display: block;
    margin-bottom: 20px;

}
.list-enter-active {
  transition: all .8s;
}
.list-enter /* .list-leave-active for <2.1.8 */ {
  opacity: 0;
  /*transform: translateX(30px);*/
}
.list-leave-active, .list-leave-to{
  display: none;
}


.type_input, .multiple_choice{
  input{
        height: 40px;
    background: white;
    border: 1px solid black;
    margin-bottom: 5px;
    color: black;
    font-size: 33px;
    line-height: 0;
    margin-right: 5px;
  }
  button{
    height: 40px;
    background: white;
    border: 1px solid black;
    margin-bottom: 5px;
    color: black;
    font-size: 33px;
    line-height: 0;
    margin-right: 5px;
  }
}

.questionBox{

  display: table;
  padding: 10px 20px;
  width: 100%;

  font-size: 20px;
  text-align: left;
  border: 1px solid grey;
  margin-bottom: 20px;
  .inner{
    display: table-cell;
  }
}
.choices{
  .choice{
    &.selected button, button.selected {
      background: #34495e;
      color: #fff;
    // box-shadow: 0px 0px 8px 0px rgb(52, 74, 93);
    }
    // &.incorrect button, // &.incorrect button{
    //   background: #920c0c;
    //   color: #fff;
    // }
    &.correct button, button.correct{
      // background: #147914;
      // color: #fff;
    }

    // &.selected.incorrect button, button.selected.incorrect {
    //   background: #920c0c;
    //   color: #fff;
    // }

    // &.selected.correct button, button.selected.correct {
    //   background: #147914;
    //   color: #fff;
    // // box-shadow: 0px 0px 8px 0px rgb(52, 74, 93);
    // }
    &.selected.incorrect button, button.selected.incorrect {
      // background: #34495e;
      // color: #fff;
    //   background: repeating-linear-gradient(
    //   -45deg,
    //   #34495e,
    //   #34495e 0px,
    //   #920c0c 10px,
    //   #920c0c 20px
    // );
    }
    &.selected.correct button {
      // background: #34495e;
      // color: #fff;
    //   background: repeating-linear-gradient(
    //   -45deg,
    //   #34495e,
    //   #34495e 0px,
    //   #147914 10px,
    //   #147914 20px
    // );
    button.selected.correct{
      // background: #147914;
      // color: #fff;
    }


    }
    button{
    transition: all .3s;
    height: 40px;
    width: 40px;
    background: white;
    border: 1px solid black;
    margin-bottom: 5px;
    color: black;
    font-size: 33px;
    line-height: 0;
    margin-right: 5px;
    }
    span{
      font-size: 20px;
    }
  }
}
.questionNumberWrapper{

.choice{
      width: 45px;
    height: 40px;
    background: #f4f7f5;
    border: 0;
    margin: 2px;
}
.answered{
  opacity: .5;
  &.correct{
    background: #109448;
  }

  &.incorrect{
    background: #ffd5d5;
  }

}
}
.amazing{
  background: red;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.drag_and_match{

  .correct{
    background: #109448;
  }

  .incorrect{
    background: #ffd5d5;
  }

  .selected.correct {
    background: #34495e;
    color: #fff;
  //   background: repeating-linear-gradient(
  //   -45deg,
  //   #34495e,
  //   #34495e 0px,
  //   #147914 10px,
  //   #147914 20px
  // );
  }
  .selected.incorrect{
    background: #34495e;
    color: #fff;
  //   background: repeating-linear-gradient(
  //   -45deg,
  //   #34495e,
  //   #34495e 0px,
  //   #920c0c 10px,
  //   #920c0c 20px
  // );
  }
  .explanation{
    margin: 5px;
    padding: 5px;
    text-align: center;
    border: 1px solid grey;

  }
}

.sorry {
  color: #920c0c;
  font-size: 18px;
  border-left: 3px solid #920c0c;
  padding-left: 5px;
  margin-bottom: 3px;
}

.congratulations {
  color: #147914;
  font-size: 18px;
  border-left: 3px solid #147914;
  padding-left: 5px;
  margin-bottom: 3px;
}

.multiple_choice_single_answer{
  .choices{
    .choice{
      
      // &.selected.incorrect button{
      //   background: #920c0c;
      // }

      // &.correct button{
      //   background: #147914;
      // }
    }
  }
}
.finishButton{
      height: 40px;
    background: white;
    border: 1px solid black;
    margin-bottom: 5px;
    color: black;
    font-size: 33px;
    line-height: 0;
    margin-right: 5px;
}
.finished{

.questionNumberWrapper{
    float: left;
    width: 30%;
}

.questionWrapper{
    float: right;
    width: 60%;  
}
}
</style>



// WEBPACK FOOTER //
// Quiz.vue?65ad2634